import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, AlertDescription } from '../components/ui/Alert';

const FitbitCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const success = searchParams.get('success');
    const error = searchParams.get('error');

    if (success === 'true') {
      setMessage('Fitbit account connected successfully!');
      setIsSuccess(true);
    } else if (error) {
      // Map error codes to user-friendly messages
      const errorMessages = {
        'access_denied': 'Fitbit connection was cancelled. Please try again if you want to connect your account.',
        'server_config': 'Server configuration error. Please contact support.',
        'missing_state': 'Security validation failed. Please try again.',
        'invalid_state': 'Invalid authentication state. Please try again.',
        'user_not_found': 'User not found. Please log in and try again.',
        'token_exchange_failed': 'Failed to complete Fitbit connection. Please try again.',
        'network_error': 'Network error. Please check your connection and try again.',
        'server_error': 'Server error. Please try again later.',
      };
      setMessage(errorMessages[error] || 'An error occurred while connecting your Fitbit account. Please try again.');
      setIsSuccess(false);
    } else {
      setMessage('Unknown response from Fitbit. Please try again.');
      setIsSuccess(false);
    }

    setProcessing(false);

    // Redirect to profile page after 2 seconds
    const timer = setTimeout(() => {
      navigate('/home');
    }, 2000);

    return () => clearTimeout(timer);
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-elev py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          {processing ? (
            <>
              <div className="flex justify-center mb-6">
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-fg-3"></div>
              </div>
              <h2 className="text-2xl font-medium text-fg mb-2">
                Processing Fitbit Connection...
              </h2>
              <p className="text-fg-3">
                Please wait while we complete the connection.
              </p>
            </>
          ) : (
            <>
              {message && (
                <Alert variant={isSuccess ? 'default' : 'destructive'} className="mb-4">
                  <AlertDescription>{message}</AlertDescription>
                </Alert>
              )}
              <p className="text-fg-3">
                Taking you to Home — we’re importing your history now.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FitbitCallbackPage;
